require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/chart/heatmap.js
// module id = muKw
// module chunks = 0